export default "__VITE_ASSET__935e9227__"